<script>
    export let img_src;
    export let rarity = "common";
    export let exists = false;

    import {rarityName, rarityColor} from "./rarities";
</script>

<div class:placeholder={!exists} style="color: {rarityColor(rarity)}">
    <img src="{img_src??""}" width="80" height="80" alt="Avatar"  draggable="false">
    <span>{rarityName(rarity)}</span>
</div>

<style>
    div {
        display: flex;
        justify-content: center;
        flex-direction: column;
        text-align: center;
    }

    .placeholder img {
        transform: rotate(-5deg);
        -webkit-filter: contrast(0) saturate(0%) brightness(0%);
        filter: contrast(0) saturate(0%) brightness(0%);
        opacity: 0.15;
    }

    .placeholder {
        opacity: 0.5;
        -webkit-filter: saturate(0);
        filter: saturate(0);
    }
</style>